@if (componentData()?.product$ | async; as product) {
  @if (features() | async; as featuresList) {
    <boels-vertical-aligner>
      <div
        class="product-attributes__layout"
        [ngClass]="{ 'no-classifications': !product?.classifications }"
      >
        @if (!!product?.classifications) {
          <table>
            <tr>
              <th colspan="2">
                <h3>
                  {{
                    'productDetails.productAttributesTab.tableHeadline'
                      | transloco
                  }}
                </h3>
              </th>
            </tr>

            @for (feature of featuresList; track feature) {
              <tr>
                <td>
                  {{ feature.name }}
                  {{ getDisplayValueUnit(feature.featureUnit?.symbol) }}
                </td>
                <td>
                  <ul>
                    @for (
                      featureValue of feature.featureValues;
                      track featureValue
                    ) {
                      <li>
                        @if (feature.type === 'boolean') {
                          @if (!!featureValue.value) {
                            <fa-icon
                              [icon]="
                                featureValue.value.toLowerCase() === 'true'
                                  ? faCheck
                                  : faTimes
                              "
                              [title]="
                                getIconTranslationTitleKey(featureValue.value)
                                  | transloco
                              "
                              class="small"
                              [ngClass]="
                                featureValue.value.toLowerCase() === 'true'
                                  ? 'green'
                                  : 'red'
                              "
                            ></fa-icon>
                          }
                        } @else {
                          {{ featureValue?.value }}
                        }
                      </li>
                    }
                  </ul>
                </td>
              </tr>
            }
          </table>
        }

        <div class="product-attributes__key-features">
          <boels-product-key-features
            [bulletPoints]="product?.bulletPoints"
          ></boels-product-key-features>

          @for (
            classification of product?.classifications;
            track classification
          ) {
            @if (classification.code === iconAttributeCode) {
              <boels-product-symbols
                [symbols]="classification"
              ></boels-product-symbols>
            }
          }
        </div>

        <boels-product-price-disclaimer
          [$product]="product"
        ></boels-product-price-disclaimer>
      </div>
    </boels-vertical-aligner>
  }
}
